module.exports = __webpack_public_path__ + "img/Authority.f5bef3f0.svg";